import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { token, user } from "../../../modules/auth";
import Loading from "../../Loading";
import { ButtonBrand, ButtonPrimary, ButtonSpan } from "../../Button";
import classnames from "classnames";
import {
  fetchHotelGroupsSnapshotReport,
  hotelGroupsSnapshotReportUnload,
} from "../../../redux/actions/venues";
import VenueSnapshotReportTableDash from "./VenueSnapshotReportTableDash";
import * as VENUE_ROUTES from "../../../Router/venue_routes";

function VenueSnapshotReport({
  isFetchingSnapshotReport,
  hotelGroupsSnapshotReportUnload,
  token,
  fetchHotelGroupsSnapshotReport,
  hotelGroupsSnapshotReport,
}) {
  const EVENT_DATE_FILTER = "event_date_from";
  const [dateFilter, setDateFilter] = useState(EVENT_DATE_FILTER);

  useEffect(() => {
    fetchHotelGroupsSnapshotReport(token, {
      dateColumn: dateFilter,
    });
  }, [dateFilter]);

  useEffect(() => {
    return () => {
      hotelGroupsSnapshotReportUnload();
    };
  }, []);

  return (
    <div>
      {!isFetchingSnapshotReport && (
        <div className={"mb-4"}>
          <div className="flex justify-between">
            <h2 className="text-2xl font-bold">Group Snapshot</h2>
            <div
              className={
                "flex-no-shrink w-1/2 flex flex-row justify-end text-xs min-h-9.5 "
              }
            >

              <ButtonSpan
                className={classnames(
                  "inline-block flex items-center px-3 border border-grey-md border-r-0",
                  {
                    "opacity-50": dateFilter === EVENT_DATE_FILTER,
                    "bg-brand": dateFilter !== EVENT_DATE_FILTER,
                  }
                )}
                onClick={() => setDateFilter("created_at")}
              >
                Enquiry Date
              </ButtonSpan>
              <ButtonSpan
                className={classnames(
                  "inline-block flex items-center px-3 border border-grey-md",
                  {
                    "opacity-50": dateFilter === "created_at",
                    "bg-brand": dateFilter !== "created_at",
                  }
                )}
                onClick={() => setDateFilter(EVENT_DATE_FILTER)}
              >
                Event Date
              </ButtonSpan>
            </div>

          </div>
        </div>
      )}

      {!isFetchingSnapshotReport &&
      hotelGroupsSnapshotReport &&
      hotelGroupsSnapshotReport.length > 0 ? (
        <VenueSnapshotReportTableDash
          data={hotelGroupsSnapshotReport}
          dateFilterColumn={dateFilter}
        />
      ) : null}
      <div className="mt-2">
        <a href={'/admin/analytics/snapshot'}>
          <ButtonPrimary>View Analytics</ButtonPrimary>
        </a>
      </div>
      {isFetchingSnapshotReport && <Loading />}
    </div>
  );
}

const mapStateToProps = state => {
  return {
    ...state.hotelGroupsSnapshotReport,
    user: user(state),
    token: token(state),
  };
};

const mapDispatchToProps = {
  fetchHotelGroupsSnapshotReport,
  hotelGroupsSnapshotReportUnload,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VenueSnapshotReport);
